module.exports = __webpack_public_path__ + "fonts/GentiumPlus-R.woff2";